const enTranslations = {
  // Hero
  'hero.title': 'Self-Service Laundry in BH - Open 6am to 11pm',
  'hero.title.meta': 'Self-Service Laundry BH | Eco Lavanderia Express',
  'hero.subtitle': 'Modern laundry with 24/7 self-service. Premium Omo and Comfort products included. Fast drying in just 45 minutes!',
  'hero.whatsapp': 'WhatsApp Us',
  'hero.location': 'View Location',
  'hero.feature.drying': 'Drying 45min',
  'hero.feature.premium': 'Premium Products',
  'hero.feature.humanized': 'Personalized Service',
  
  // Services
  'services.title': 'Our Services',
  'services.subtitle': 'Complete solutions to care for your clothes',
  'services.selfService.title': 'Self-Service',
  'services.selfService.description': 'Modern 10kg machines. Wash and dry your clothes yourself.',
  'services.selfService.price': 'From $16.99',
  'services.fullService.title': 'Full Service',
  'services.fullService.description': 'Leave it to us! We wash, dry and fold your clothes.',
  'services.fullService.price': 'From $25.00',
  'services.everyday.title': 'Everyday Clothes',
  'services.everyday.description': 'T-shirts, pants, underwear and towels.',
  'services.everyday.price': 'From $12.00',
  'services.bedding.title': 'Comforters and Blankets',
  'services.bedding.description': 'Large items with special treatment.',
  'services.bedding.price': 'From $30.00',
  'services.humanized.title': 'Personalized Service',
  'services.humanized.description': 'Our team is always ready to help you with attention and care. We know that each piece has its value and we take care of everything with dedication.',
  'services.humanized.cta': 'Contact Us',
  'services.differentials.title': 'Our Differentials',
  'services.differentials.care': 'Special Care',
  'services.differentials.care.desc': 'Personalized treatment for each type of clothing',
  'services.differentials.fast': 'Speed',
  'services.differentials.fast.desc': 'Drying in 45 minutes',
  'services.differentials.quality': 'Quality',
  'services.differentials.quality.desc': 'Premium Omo and Comfort products',
  'services.differentials.care2': 'Care with Delicate Clothes',
  'services.differentials.care2.desc': 'Special programs for sensitive pieces',
  'services.differentials.support': 'Always Available Support',
  'services.differentials.support.desc': 'Team ready to help',
  
  // Pricing
  'pricing.title': 'Prices and Hours',
  'pricing.subtitle': 'Transparency and ease for you',
  'pricing.selfService.title': 'Self-Service',
  'pricing.selfService.price': '$16.99',
  'pricing.selfService.period': 'per wash',
  'pricing.selfService.features.washing': 'Complete washing',
  'pricing.selfService.features.products': 'Products included (Omo and Comfort)',
  'pricing.selfService.features.drying': 'Drying 45 minutes',
  'pricing.selfService.features.wifi': 'Free Wi-Fi while waiting',
  'pricing.selfService.cta': 'Start Now',
  'pricing.fullService.title': 'Full Service',
  'pricing.fullService.price': '$29.99',
  'pricing.fullService.period': 'per wash',
  'pricing.fullService.popular': 'Most Popular',
  'pricing.fullService.features.full': 'Complete Washing + Drying',
  'pricing.fullService.features.fold': 'We fold your clothes',
  'pricing.fullService.features.products': 'Premium products included',
  'pricing.fullService.features.delivery': 'Delivery in 24h',
  'pricing.fullService.features.support': 'Personalized service',
  'pricing.fullService.cta': 'Request Service',
  'pricing.schedule.title': 'Hours',
  'pricing.schedule.days': 'Monday to Sunday',
  'pricing.schedule.hours': '6am to 11pm',
  'pricing.schedule.last': 'Last service: 10:30pm',
  'pricing.schedule.info': '24/7 self-service available via app',
  'pricing.schedule.cta': 'View on Map',
  
  // Space
  'space.title': 'Our Space',
  'space.subtitle': 'Modern and comfortable environment',
  'space.amenities.title': 'Amenities',
  'space.amenities.wifi': 'Free Wi-Fi',
  'space.amenities.ac': 'Air Conditioning',
  'space.amenities.parking': 'Delivery Service',
  'space.amenities.cameras': 'Security Cameras',
  'space.amenities.eco': 'Ecological Products',
  'space.amenities.accessibility': 'Accessibility',
  'space.amenities.led': 'LED Lighting',
  'space.amenities.safe': 'Safe Environment',
  'space.cta': 'Visit Us',
  
  // Location
  'location.title': 'Our Location',
  'location.subtitle': 'Easy access and delivery in the area',
  'location.address': 'Address',
  'location.address.street': 'Av. Álvares Cabral, 894',
  'location.address.neighborhood': 'Lourdes, Belo Horizonte - MG',
  'location.phone': 'Phone / WhatsApp',
  'location.phone.number': '(31) 99990-1010',
  'location.hours': 'Business Hours',
  'location.hours.days': 'Monday to Sunday',
  'location.hours.time': '6am to 11pm',
  'location.highlights': 'Reference Points',
  'location.highlights.shopping': 'Near Minas Shopping',
  'location.highlights.parking': 'Delivery in the area',
  'location.highlights.access': 'Easy access via Av. Álvares Cabral',
  'location.cta': 'Get Directions',
  
  // Reviews
  'reviews.title': 'What Our Customers Say',
  'reviews.subtitle': 'Real reviews from people who have used our services',
  'reviews.cta': 'Leave Your Review',
  
  // FAQ
  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Get your questions answered about our services',
  
  // Footer
  'footer.about': 'About',
  'footer.about.description': 'Modern laundry with 24/7 self-service and full service. We care for your clothes with love and dedication.',
  'footer.quickLinks': 'Quick Links',
  'footer.contact': 'Contact',
  'footer.contact.address': 'Av. Álvares Cabral, 894 - Lourdes, BH',
  'footer.contact.phone': '(31) 99990-1010',
  'footer.contact.email': 'contact@ecolavanderia.com.br',
  'footer.social': 'Social Media',
  'footer.rights': 'All rights reserved.',
  
  // NotFound
  'notfound.title': 'Page Not Found',
  'notfound.description': 'Oops! The page you are looking for does not exist or has been moved.',
  'notfound.home': 'Back to Home',
  'notfound.contact': 'Contact Us',
  'notfound.links': 'Useful links:',
  'notfound.services': 'Services',
  'notfound.location': 'Location',
  'notfound.reviews': 'Reviews',
};

export default enTranslations;
